import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-be2f347c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "vip-result-dialog"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}, null, -1));
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "action"
};
import { watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { sensorsClick } from '@/utils/sensors';
export default {
  __name: 'VipSuccess',
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  emits: ['visible', 'opened', 'opened'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    const store = useStore();
    let autoHideTimer = null;
    let clickTimer = null;
    const reviewExpectedText = computed(() => {
      const resultLink = `<a class="apply-result-then"> ${t('appResultThen')} </a>`;
      return t('reviewExpectedTime', {
        resultLink
      });
    });
    const methods = {
      reportHide() {
        emit('close');
      }
    };
    watch(() => props.visible, visible => {
      if (visible) {
        if (autoHideTimer) {
          clearTimeout(autoHideTimer);
          autoHideTimer = null;
        }
        autoHideTimer = setTimeout(() => {
          methods.reportHide();
        }, 3000);
        if (clickTimer) {
          clearTimeout(clickTimer);
          clickTimer = null;
        }
        clickTimer = setTimeout(() => {
          const resultDom = document.querySelector('.apply-result-then');
          resultDom?.addEventListener('click', () => {
            store.commit('loan/SET_TAB', 'Vip');
            store.commit('loan/SET_VIP_TAB', 'History');
            sensorsClick({
              button_name: 'vip_dialog_my_history_btn'
            });
          });
        }, 500);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.visible,
        onClosed: methods.reportHide,
        "destroy-on-close": "",
        "close-on-click-modal": true,
        "close-on-press-escape": true,
        width: "480px"
      }, {
        default: _withCtx(() => [_hoisted_2, _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)('approvalInProgress')), 1), _createElementVNode("div", {
          class: "guide",
          innerHTML: _unref(reviewExpectedText)
        }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          class: _normalizeClass(["flex-1 confirm", {
            'loading': _ctx.loading
          }]),
          type: "main",
          loading: _ctx.loading,
          onClick: methods.reportHide
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('confirm')), 1)]),
          _: 1
        }, 8, ["class", "loading", "onClick"])])]),
        _: 1
      }, 8, ["model-value", "onClosed"])]);
    };
  }
};